import React, { useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setPayReportDownloadJob } from 'src/reducers/employees/employeePays';
import { MAX_POLLING_INTERVAL } from 'src/constants/Generals';
import Loading from 'src/components/Loading';
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import Hint from 'jbc-front/components/Hint';
import PayReportsDownloadContainer from '../containers/PayReportsDownloadModalContainer';
import styles from '../components/PayReportsCreateModal.scss';

const PayReportsCreateModal = ({
  isOpen,
  hideModal,
  payrollRulesGroups,
  paymentDate,
  uniquePaymentDates,
  dispatch,
  fetchZipJobStatus,
}) => {
  const [openDownloadModal, setOpenDownloadModal] = useState(false);
  const [downloadLanguage, setDownloadLanguage] = useState(null);
  const downloadObjVi = _.get(_.find(uniquePaymentDates, { value: paymentDate }), 'downloadObjVi');
  const downloadObjEn = _.get(_.find(uniquePaymentDates, { value: paymentDate }), 'downloadObjEn');
  const { t } = useTranslation();

  const setDownloadJob = (lang) => {
    setPayReportDownloadJob(payrollRulesGroups, paymentDate, uniquePaymentDates, lang)(dispatch);
  };

  const pollUpdatePayConfirmationStatus = async (downloadObj, interval) => {
    let newInterval = interval;

    if (isFileCreating(downloadObj)) {
      await fetchZipJobStatus(_.get(downloadObj, 'id'));
      if (newInterval < MAX_POLLING_INTERVAL) {
        newInterval *= 2;
      }
    }
    setTimeout(pollUpdatePayConfirmationStatus, newInterval, downloadObj, newInterval);
  };

  const isFileCreating = (downloadObj) => {
    return _.includes(['waiting', 'running'], downloadObj?.status);
  };

  const isFileCreated = (downloadObj) => {
    return _.includes(['success', 'failed'], downloadObj?.status);
  };

  const handleOpenDownloadModal = (language) => {
    setDownloadLanguage(language);
    setOpenDownloadModal(true);
  };

  const closeDownloadModal = () => {
    setOpenDownloadModal(false);
    setDownloadLanguage(null);
  };

  return (
    <>
      <CommonModal isOpen={isOpen} hideModal={hideModal} ariaHideApp={false}>
        <React.Fragment>
          <CommonModal.Header hideModal={hideModal}>
            {t('features.EmployeePays.components.PayReportsCreateModal.Create_payslip_in_batch')}
            <Hint text={t('features.EmployeePays.components.PayReportsCreateModal.unconfirm_month_before_create_hint')} />
          </CommonModal.Header>
          <CommonModal.Body>
            <div className={styles.title}>{t('features.EmployeePays.components.PayReportsCreateModal.vi_payslips')}</div>
            <div className={styles.modal_btn}>
              {isFileCreating(downloadObjVi) ? (
                <div className={styles.loading}>
                  <Button type="button" primary disabled icon={<Loading />} data-testid="creating-vi">
                    {t('features.EmployeePays.components.PayReportsCreateModal.creating')}
                  </Button>
                </div>
              ) : (
                <Button
                  type="button"
                  primary
                  onClick={() => setDownloadJob('vi')}
                  data-testid="create-vi"
                  disabled={isFileCreated(downloadObjVi)}
                >
                  {t('features.EmployeePays.components.PayReportsCreateModal.create')}
                </Button>
              )}
              <Button
                success
                disabled={!isFileCreated(downloadObjVi)}
                className="u-mr20"
                data-testid="download-vi"
                onClick={() => handleOpenDownloadModal('vi')}
              >
                {t('features.EmployeePays.components.PayReportsCreateModal.download')}
              </Button>
            </div>
            <br />

            <div className={styles.title}>{t('features.EmployeePays.components.PayReportsCreateModal.en_payslips')}</div>
            <div className={styles.modal_btn}>
              {isFileCreating(downloadObjEn) ? (
                <div className={styles.loading}>
                  <Button primary disabled icon={<Loading />} data-testid="creating-en">
                    {t('features.EmployeePays.components.PayReportsCreateModal.creating')}
                  </Button>
                </div>
              ) : (
                <Button primary onClick={() => setDownloadJob('en')} data-testid="create-en" disabled={isFileCreated(downloadObjEn)}>
                  {t('features.EmployeePays.components.PayReportsCreateModal.create')}
                </Button>
              )}
              <Button
                success
                className="u-mr20"
                disabled={!isFileCreated(downloadObjEn)}
                onClick={() => handleOpenDownloadModal('en')}
                data-testid="download-en"
              >
                {t('features.EmployeePays.components.PayReportsCreateModal.download')}
              </Button>
            </div>
          </CommonModal.Body>
          <CommonModal.Footer>
            <Button onClick={hideModal} className="u-mr20" data-testid="cancel">
              {t('features.EmployeePays.components.PayReportsCreateModal.cancel')}
            </Button>
          </CommonModal.Footer>
        </React.Fragment>
      </CommonModal>
      <PayReportsDownloadContainer
        isOpen={openDownloadModal}
        hideModal={closeDownloadModal}
        downloadId={downloadLanguage === 'vi' ? downloadObjVi?.id : downloadObjEn?.id}
      />
    </>
  );
};

export default connect()(PayReportsCreateModal);
